import { cn } from '@/shared/lib'

type Props = {
  onClick: () => void
}

export const DeleteButton = ({ onClick }: Props) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={cn(
        'typo-label1 absolute top-[34px] right-6 cursor-pointer rounded-sm font-medium text-black',
        'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
      )}
      onClick={onClick}
    >
      전체 삭제
    </div>
  )
}
